import React from "react";
import { useTranslation } from "react-i18next";
import ModalContainer from "../../../containers/Modal/ModalContainer";

const ModalAlertToCloneLastInterview = ({showModal, submitButtonAction, setShowModal }) => {
  const { t } = useTranslation();

  return (
    <ModalContainer
      modalTitle={t("Warning")}
      isOpen={showModal}
      submitButtonAction={() => submitButtonAction()}
      submitButtonTitle={t("Confirm")}
      submitButtonType="button"
      cancelButtonAction={() => setShowModal(false)}
      cancelButtonTitle={t("Cancel")}
      closeModal={() => setShowModal(false)}
      crossmarkAction={() => setShowModal(false)}
    >
      {t("The pre-candidate already exists. The data of the pre-candidate or the last completed interview for him will be copied, or the last unfinished interview will be opened, if there is one. The data of the fields already filled in will be replaced. Do you want to continue ?")}
    </ModalContainer>
  );
};

export default ModalAlertToCloneLastInterview;
